import React, { useState, useEffect } from "react";
import ValidatedImage from "../../utils/ValidatedImage"
import CinDigitalDialog from "./CinDigitalDialog/CinDigitalDialog"
import CinDigitalOCR from "./CinDigitalOCR/CinDigitalOCR"
import { CircularProgress } from '@material-ui/core';
import axios from "axios";
import { useTranslation } from "react-i18next";

function CinDigitalCard(props){

    const { t } = useTranslation()

    const { cin_digital } = props

    const [OCR, setOCR] = useState(null)
    const [OCRFileType, setOCRFileType] = useState(null)
    const [OCRPictureOpen, setOCRPictureOpen] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (cin_digital.ocr_key){
                axios.get('/dash/ocr/' + cin_digital.ocr_key).then( response => {
                    let hasPDF = response.data.pdf || response.data.file_metadata?.file_type === "pdf"
                    setOCRFileType(hasPDF ? "pdf" : "image");
                    let ocr_data = response.data.processed_object
                    if (ocr_data == null) throw new Error()
                    setOCR(ocr_data);
                }).catch(error => {
                    setOCR(undefined)
                    setOCRFileType(undefined)
                })
            }
        }, 500);
        return () => {
            clearTimeout(timer)
        }
    }, [cin_digital])

    let getPictureContent = (picture) => {
        if (picture === undefined) {
            return (          
                <div 
                    className={["labelText", "normalMediumSize"].join(" ")} 
                    style={{textAlign:"center", margin:"auto"}}
                >
                    {t("information_unavailable")}
                </div>
            )
        } 
        else{
            return (
                <ValidatedImage
                    image_key={picture}
                    dash_api_endpoint_url={'/dash/ocr/image'}
                    imageStyle = {{margin:"auto", width:"100%", height:"100%",position:"absolute", top:"-9999px",bottom:"-9999px",left:"-9999px",right:"-9999px", borderRadius: "5px", objectFit:"contain"}}
                    imageAlt = {"Foto do Documento"}
                    fileType={OCRFileType}
                />
            );
        }
    };

    if (OCR === null || OCRFileType === null) {
        return (
            <div style={{minHeight: "250px"}} className="analysisCard">
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("CIN Digital OCR")}</div>
                <div style={{display:"flex", flexGrow:"1"}}>
                    <CircularProgress style={{margin:"auto"}} />
                </div>
            </div>
        );    
    }
    else if (OCR === undefined || OCRFileType === undefined){
        return (
            <div style={{minHeight: "250px"}} className="analysisCard">
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("CIN Digital OCR")}</div>
                <div style={{display:"flex", flexGrow:"1"}}>
                    <div className={["labelText", "normalMediumSize"].join(" ")} style={{margin:"auto"}}>
                        {t("information_unavailable")}
                    </div>
                </div>
            </div>
        )
    }
    else {
        return (
            <div style={{minHeight: "450px"}} className="analysisCard">
                <div className={["blueText", "subtitleSize"].join(" ")}>{t("CIN Digital OCR")}</div>
                <div className="internalCardContainer" style={{display:"flex", flexGrow:"1", maxHeight:"450px",flexDirection: "row"}}>
                    <div style={{display:"flex", width:"28%", maxHeight:"64vw", flexDirection: "column", marginRight:"31px"}}>
                        <div onClick={()=>setOCRPictureOpen(true)} style={{display:"block", width:"100%", height:"90%", margin: "0 auto", overflow:"hidden", position:"relative", alignItems: "center", justifyContent: "center",borderRadius: "5px", cursor:"pointer"}}>
                            {cin_digital.ocr_key && getPictureContent( cin_digital.ocr_key )}
                        </div>
                        {cin_digital.ocr_key&&
                        <div
                            onClick={()=>setOCRPictureOpen(true)}
                            className={["blueText", "normalSmallSize", "link"].join(" ")}
                            style={{margin:"10px", textAlign:"center"}}
                        >
                            {`${t("see")} ${t(OCRFileType)}`}
                        </div>}
                    </div>
                    <CinDigitalOCR OCR={OCR} />
                    {cin_digital.ocr_key&&
                        <CinDigitalDialog
                            open={OCRPictureOpen}
                            onClose={()=>setOCRPictureOpen(false)}
                            image_list={[cin_digital.ocr_key]}
                            fileType={OCRFileType}
                    />}
                </div>
            </div>
        );
    }
}

export default CinDigitalCard